import {Injector} from '@angular/core';

import {Globals} from './globals';

/* -------------------------------------------------------------------------------------------------------------- */
export * from './multi-key-map';
/* -------------------------------------------------------------------------------------------------------------- */
export * from './api-names.types';
export * from './map.extension';
export * from './storage.extension';
export * from './json.extension';
export * from './string.extension';
export * from './array.extension';
export * from './set.extension';
export * from './globals';
export * from './html-element.extension';
export * from './reflact.extension';
export * from './object.extension';
export * from './regexp.extension';
export * from './stack.extension';
export * from './boolean.extension';
export * from './date-time.extension';
export * from './store.extension';
export * from './file.types';
export * from './typings';
export * from './store.types';
export * from './style.types';
export * from './enum.extension';
export * from './validators';
export * from './common.decorators';
export * from './signal-store';
/* -------------------------------------------------------------------------------------------------------------- */
export let MainInjector: Injector;

export function setMainInjector(injector: Injector) {
	MainInjector = injector;
}

/* -------------------------------------------------------------------------------------------------------------- */
export let workbox: import('workbox-window').Workbox;

export function setGlobalWorkbox(wb: import('workbox-window').Workbox) {
	if (wb === null) workbox = null;
	if (workbox) throw new Error('Workbox is already set');
	workbox = wb;
}

/* -------------------------------------------------------------------------------------------------------------- */
declare global {
	interface Window extends Globals.IGlobals {
		Sentry: any;
		workbox: import('workbox-window').Workbox;
	}
}

/* -------------------------------------------------------------------------------------------------------------- */
// for types that can be used as a function or as a value -> if the type is a function, return the value of the function, otherwise return the value
globalThis.simplifyCallable = function <T>(value: ((...args: any[]) => T) | T, args?: any[]): T {
	if (typeof value === 'function') return (value as any)(args);
	return value as T;
};

/* -------------------------------------------------------------------------------------------------------------- */
globalThis.isDcBackendError = function (error: import('@angular/common/http').HttpErrorResponse): error is DcBackendError {
	const errorBody = error.error;
	return Reflect.has(errorBody, 'error');
};

globalThis.extractDcBackendErrorData = function (error: import('@angular/common/http').HttpErrorResponse): DcBackendErrorData {
	return isDcBackendError(error)
		? {
				message: error.error.error,
				details: error.error?.info || '',
				errorCode: error.status,
				ok: error.ok,
			}
		: null;
};
/* -------------------------------------------------------------------------------------------------------------- */
globalThis.buildType = function <TypeAsString extends buildableTypeNames = buildableTypeNames>(typeAsString: TypeAsString): buildableType<TypeAsString> {
	return typeAsString as buildableType<TypeAsString>;
};

//declare function transformer(mapping: Record<string, any>): (target: any, propertyKey: string) => void;
// /* -------------------------------------------------------------------------------------------------------------- */
// // another signature for the transformer function using a function as a mapping
// declare function transformer<T>(mapping: (value: T) => T): (target: any, propertyKey: string) => void;
globalThis.transformer = function transformer<T = any>(mapping: Record<string, T> | ((value: T) => T)) {
	if (typeof mapping === 'function') {
		return function (target: any, propertyKey: string) {
			const backingField = `_${propertyKey}`;
			Object.defineProperty(target, propertyKey, {
				get: function () {
					return mapping(this[backingField]); // Use the backing field
				},
				set: function (value) {
					this[backingField] = mapping(value); // Use the backing field
				},
			});
		};
	} else {
		const mapper = new Map(Object.entries(mapping)); // Corrected from Map.prototype.fromRecord to new Map and Object.entries
		return function (target: any, propertyKey: string) {
			const backingField = `_${propertyKey}`;
			Object.defineProperty(target, propertyKey, {
				get: function () {
					return mapper.getValue(this[backingField]); // Use the backing field
				},
				set: function (value) {
					this[backingField] = mapper.getValue(value); // Use the backing field
				},
			});
		};
	}
};
/* -------------------------------------------------------------------------------------------------------------- */
